var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#212934",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.781 2.91A7.916 7.916 0 0 0 8.146.577c-2.128 0-4.13.83-5.635 2.335A7.92 7.92 0 0 0 .177 8.547c0 4.307 4.072 7.89 6.259 9.814.304.267.566.498.776.693.262.245.598.368.934.368.336 0 .673-.123.935-.368.209-.195.471-.426.775-.693 2.188-1.925 6.26-5.507 6.26-9.814A7.92 7.92 0 0 0 13.78 2.91zM9.127 17.533c-.31.273-.579.51-.8.716a.266.266 0 0 1-.362 0c-.221-.207-.49-.443-.8-.716-2.056-1.81-5.884-5.177-5.884-8.985 0-3.786 3.08-6.867 6.865-6.867 3.786 0 6.865 3.08 6.865 6.867 0 3.808-3.827 7.176-5.884 8.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.146 4.733a3.516 3.516 0 0 0-3.512 3.513 3.516 3.516 0 0 0 3.512 3.512 3.516 3.516 0 0 0 3.512-3.512 3.516 3.516 0 0 0-3.512-3.513zm0 5.921a2.411 2.411 0 0 1-2.408-2.408 2.411 2.411 0 0 1 2.408-2.409 2.411 2.411 0 0 1 2.408 2.409 2.411 2.411 0 0 1-2.408 2.408z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlack);
export default __webpack_public_path__ + "static/media/locationBlack.a78985201f76f7458156d41ec6dffc7f.svg";
export { ForwardRef as ReactComponent };